import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record } from 'immutable';
var defaults = {
  communicationTypeId: null,
  label: '',
  required: false
};

var LegalConsentCheckbox = /*#__PURE__*/function (_Record) {
  _inherits(LegalConsentCheckbox, _Record);

  function LegalConsentCheckbox() {
    _classCallCheck(this, LegalConsentCheckbox);

    return _possibleConstructorReturn(this, _getPrototypeOf(LegalConsentCheckbox).apply(this, arguments));
  }

  return LegalConsentCheckbox;
}(Record(defaults));

export { LegalConsentCheckbox as default };